<button [matMenuTriggerFor]="menu" mat-icon-button>
  <mat-icon>{{ icon }}</mat-icon>
</button>
<mat-menu #menu="matMenu" class="height-300 mat-menu-list">
  <div fxFlexLayout="row" fxFlexLayoutGap="10px" >

    <iot-platform-ui-async-autocomplete
      (click)="$event.preventDefault(); $event.stopPropagation()"
      (reset)="clear?.emit()"
      (search)="search?.emit($event)"
      [autocomplete]="false"
      [data]="data"
      [debounceTime]="150"
      [displayKey]="displayKey"
      [minLength]="0"
      [placeholder]="placeholder"
      fxFlex
    />
    @for (item of data; track item; let i = $index) {
      <button (click)="selectItem?.emit(item)" [matTooltip]="item[displayKey]" mat-menu-item>{{ item[displayKey] | uppercase }}</button>
      @if (i < item?.length - 1) {
        <mat-divider></mat-divider>
      }
    }
  </div>

  @if (!data?.length) {
    <div class="no-data-message" fxFlexAlign="center center" fxFlexLayout="row">
      <p>{{ noDataMessage | translate }}</p>
    </div>
  }
</mat-menu>
